<template>
    <modal
        name="morda-lenta-win"
        @before-open="beforeOpen"
        @before-close="beforeClose"
        :classes="['v--modal', 'morda-lenta-win']"
        :width="730"
        :height="'auto'"
        :adaptive="true"
    >
        <div class="modal-title">Поздравляем!</div>
        <div class="modal-close" @click="close"></div>
        <div class="modal-body">
            <img
                v-if="prize.image"
                :src="prize.image"
                :alt="prize.name"
                class="modal-image"
            >
            <div class="modal-subtitle">
                Вы получаете приз <span class="prize">{{ prize.name }}</span> в Фотоленте за {{ count }} фото в комбинации {{ combination }}
            </div>
            <div class="buttons-row">
                <button
                    @click="close"
                    class="button"
                >ОК</button>
            </div>
        </div>
    </modal>
</template>

<script>
    import {checkScroll} from '@/mixins/checkScroll';

    export default {
        name: 'MordaLentaWin',
        mixins: [
            checkScroll
        ],
        data() {
            return {
                prize: '',
                count: '',
                combination: ''
            }
        },
        methods: {
            beforeOpen(event) {
                this.checkScroll();
                this.prize = event.params.prize;
                this.count = event.params.count;
                this.combination = event.params.combination;
            },
            beforeClose() {
                this.checkRemoveScroll();
            },
            close() {
                this.$modal.hide('morda-lenta-win');
            }
        }
    }
</script>
